import React from 'react';
import Button from '@hero/ui-kit/inputs/Button';

import { CODE_ACTION_LABELS, careReasonText, noteActionLabel } from '../constants';
import { actionKey, rowNote } from '../presentation';
import * as Style from '../style.module.scss';
import { ActionTarget, CareRow } from '../types';

type Props = {
    row: CareRow;
    disabled: boolean;
    onAction: (target: ActionTarget) => void;
};

const RowActions: React.FC<Props> = ({ row, disabled, onAction }) => (
    <div className={Style.codeActions}>
        {row.code_actions.map((action) => (
            <Button
                key={actionKey(action)}
                size="small"
                variant="outlineSecondary"
                width="natural"
                noDefaultMargin
                disabled={disabled}
                onClick={() => onAction({ row, action })}
            >
                {action.action === 'note' ? noteActionLabel(rowNote(row)) : CODE_ACTION_LABELS[action.action]}
                {action.warning_kinds?.length ? `: ${careReasonText(action.warning_kinds[0])}` : ''}
            </Button>
        ))}
    </div>
);

export default RowActions;
